import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { primaryStyles, secondaryStyles } from './styles/index';
import Typeahead from './Typeahead';

export const TypeAheadStyles = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

const PrimaryTypeahead = withStyles(primaryStyles, { withTheme: true })(Typeahead);
const SecondaryTypeahead = withStyles(secondaryStyles, { withTheme: true })(Typeahead);

export default function StyledTypeAhead(props) {
  // eslint-disable-next-line react/prop-types
  const { typeaheadStyling, ...rest } = props;

  return typeaheadStyling === TypeAheadStyles.SECONDARY ? (
    <SecondaryTypeahead {...rest} />
  ) : (
    <PrimaryTypeahead {...rest} />
  );
}
